<template>
    <div class="rate">
        <label  title="text" :class="rate(5)">5 stars</label>
        <input type="radio" name="rate" disabled/>
        <label  title="text" :class="rate(4)">4 stars</label>
        <input type="radio" name="rate" value="3" />
        <label  title="text" :class="rate(3)">3 stars</label>
        <input type="radio" name="rate" value="2" />
        <label  title="text" :class="rate(2)">2 stars</label>
        <input type="radio" name="rate" value="1" />
        <label  title="text" :class="rate(1)">1 star</label>
    </div>
</template>
<script>
    export default {
        name: 'star-rating',
        props: ['rating'],
        data() {
            return {
            }
        },

        methods : {
          rate(rateLevel) {
              if(this.rating >= rateLevel) {
                  return 'rated';
              } else {
                  return '';
              }

          }
        },

        created() {
            switch (this.rating) {
                case 1:
                    return;

                default:
                    return;

            }
        }
    }
</script>

<style scoped>
    *{
        margin: 0;
        padding: 0;
    }
    .rate {
        float: left;
        clear: both;
        height: 46px;
        padding: 0 10px;
        padding-left: 0;
    }
    .rate:not(:checked) > input {
        position:absolute;
        top:-9999px;
    }
    .rate:not(:checked) > label {
        float:right;
        width:1em;
        overflow:hidden;
        white-space:nowrap;
        cursor:pointer;
        font-size:30px;
        color:#ccc;
    }
    .rate:not(:checked) > label:before {
        content: '★ ';
    }
    .rate > input:checked ~ label {
        color: #ffc700;
    }
    /*.rate:not(:checked) > label:hover,*/
    /*.rate:not(:checked) > label:hover ~ label {*/
    /*    color: #deb217;*/
    /*}*/
    /*.rate > input:checked + label:hover,*/
    /*.rate > input:checked + label:hover ~ label,*/
    /*.rate > input:checked ~ label:hover,*/
    /*.rate > input:checked ~ label:hover ~ label,*/
    /*.rate > label:hover ~ input:checked ~ label {*/
    /*    color: #c59b08;*/
    /*}*/
    .rated {
        color: #deb217 !important;
    }
</style>